import { Component, OnInit,Input } from '@angular/core';
import { GlobalService } from '@common/global';
@Component({
  selector: 'app-ui-category',
  templateUrl: './ui-category.component.html',
  styleUrls: ['./ui-category.component.sass']
})
export class UiCategoryComponent implements OnInit {
  @Input('a') application: string;
  @Input('c') component: string;
  @Input('category') category: object;
  @Input('className') className: string;
  constructor(private _global: GlobalService) { }

  ngOnInit(): void {
  }

}
